import { render } from "./CommLogList.vue?vue&type=template&id=546249d2"
import script from "./CommLogList.vue?vue&type=script&lang=js"
export * from "./CommLogList.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/star-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__